<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-23                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-button :variant="variant" v-on:click.stop="handleClick" class="mr-1">{{label}}</b-button>
</template>

<script>
export default {
  name: "yega1-button-edit-item",
  props:{
    variant:{
      type:String,
      default:'primary'
    },
    label:{
      type:String,
      default:'Edit'
    },
    item:{
      type:Object,
      required:true
    }
  },
  inject:{
    editItem: 'editItem'
  },
  methods:{
    handleClick(){
      this.editItem(this.item);
    }
  }
}
</script>

<style scoped>

</style>
